// Number helpers for the AI developer dashboard. Costs are tiny (fractions of a
// cent per turn), so they get more decimals than the restaurant's money does.

export function formatMs(ms: number): string {
  if (!Number.isFinite(ms) || ms <= 0) return '—'
  if (ms < 1000) return `${Math.round(ms)} ms`
  return `${(ms / 1000).toFixed(ms >= 10_000 ? 0 : 1)} s`
}

export function formatUsd(v: number, digits = 4): string {
  return `$${(Number.isFinite(v) ? v : 0).toFixed(digits)}`
}

export function formatPct(share: number): string {
  return `${Math.round((Number.isFinite(share) ? share : 0) * 100)}%`
}

export function formatAgo(ts: number, now = Date.now() / 1000): string {
  const s = Math.max(0, now - ts)
  if (s < 60) return `${Math.round(s)}s ago`
  if (s < 3600) return `${Math.round(s / 60)}m ago`
  if (s < 86400) return `${Math.round(s / 3600)}h ago`
  return `${Math.round(s / 86400)}d ago`
}

/** A Counter-style map as rows, biggest first. */
export function sortedCounts(counts: Record<string, number> | undefined): [string, number][] {
  return Object.entries(counts ?? {})
    .filter(([k]) => k && k !== 'null')
    .sort((a, b) => b[1] - a[1])
}

/** What a lane means, in the words the dashboard shows. */
export const LANE_LABELS: Record<string, string> = {
  jev_fast: 'Jev opened a screen',
  jev_tool: 'Jev made the data call',
  base: 'Claude answered',
  cache: 'Answered from cache',
  offline: 'Offline (no LLM key)',
  upper: 'Sonnet (retired)',
}
